/* eslint-disable @typescript-eslint/camelcase */

import { Status } from 'hooks/requests/fetchUtils';
import useFetchApi from 'hooks/useFetchApi';
import useApplicationBasedOverrides from 'hooks/useApplicationBasedOverrides';
import { useCallback, useState } from 'react';

export enum EmailType {
  Disclosure = 'disclosures',
  NotBestApr = 'not_best_apr',
}

type EmailDisclosureHook = () => [
  (emailAddress: string, emailType: EmailType) => Promise<void>,
  Status,
  boolean,
];

export class EmailDisclosureError extends Error {}

// TODO: 'fix path'
const PATH = '/api/email';

const useEmailDisclosure: EmailDisclosureHook = () => {
  const [error, setError] = useState<boolean>(false);
  const [status, fetch] = useFetchApi();
  const overrideAttributes = useApplicationBasedOverrides();

  const sendDisclosure = useCallback(
    async (emailAddress: string, emailType: EmailType) => {
      setError(false);
      const response = await fetch(PATH, {
        method: 'POST',
        body: {
          ...overrideAttributes,
          emailAddress,
          emailType,
        },
      });

      if (!response.ok) {
        setError(true);
        return Promise.reject(new EmailDisclosureError());
      }
    },
    [fetch, overrideAttributes],
  );

  return [sendDisclosure, status, error];
};

export default useEmailDisclosure;
